/* eslint-disable */

import Vue from 'vue';
import { concatenate, currency, formatDate } from '@/support/String';

Vue.filter('concatenateString', (value: string) => {
  if (value.length >= 50) {
    return `${value.slice(0, 50)}...`;
  } else {
    return value;
  }
});

Vue.filter('formatDate', (date: string) => {
  if (date === '-') {
    return '-';
  }

  if (date === '0000-00-00 00:00:00') {
    return '-';
  }

  if (! date) {
    return '-';
  }

  return formatDate(date);
});

Vue.filter('currency', (value: any) => currency(value, 'EUR'));
